import swal from 'sweetalert';

const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

window.addEventListener("load", function () {
    let form = this.document.getElementById('html-input-footer-form');
    let inp = form.querySelector('.js-input');
    let good = form.querySelector('.js-good');

    let reset = form.querySelector('.js-good');
    reset.addEventListener('click', function() {
        inp.classList.remove('upsd-footer__form_hidden');
        good.classList.add('upsd-footer__form_hidden');
    });

    if(!form) {
        return;
    }

    function validEmail(emailInput) {
        if (EMAIL_REGEXP.test(emailInput.value)) {
            return true;
        } else {
            return false;
        }
    }

    form.querySelector('input').addEventListener('keyup', function(e){
        let block =  e.currentTarget.closest('fieldset');
        if (validEmail(e.currentTarget)) {
            block.classList.remove('error');
        } else {
            block.classList.add('error');
        }
    });

    form.addEventListener('submit', function(e) {
        e.preventDefault();

        let mail = e.currentTarget.querySelector('input').value;
        let block =  e.currentTarget.querySelector('input').closest('fieldset');
        block.classList.remove('error');

        if(!validEmail(e.currentTarget.querySelector('input'))) {
            return;
        }


        fetch('/ajax/subscribe.php?mail=' + mail)
            .then(function(response) {
                return response.json()
            })
            .then(function(result) {
                if(result.error) {
                    block.classList.add('error');
                } else {
              
                    inp.classList.add('upsd-footer__form_hidden');
                    good.classList.remove('upsd-footer__form_hidden');
                }
            })
            .catch(function(error){
                block.classList.add('error');
            });
    }); 
}); 